var React = require('react');

function IconDownloadData (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M50,5C25.1,5,5,25.1,5,50c0,24.8,20.1,45,45,45s45-20.2,45-45C95,25.1,74.9,5,50,5L50,5z M70.1,34.8H59.5V24.2\n\tL70.1,34.8z M71.3,76.1c0,0.5-0.4,0.9-0.9,0.9H29.6c-0.5,0-0.9-0.4-0.9-0.9V23.9c0-0.5,0.4-0.9,0.9-0.9H55v15.5\n\tc0,0.5,0.4,0.9,0.9,0.9h15.5L71.3,76.1L71.3,76.1z M52.4,59.7V42.6c0-1.4-1.1-2.5-2.4-2.5c-1.3,0-2.4,1.1-2.4,2.5v17.2\n\tc0,0-3.3-3.3-3.4-3.4c-1-1-2.5-1-3.4,0c-1,1-1,2.5,0,3.4c0,0.1,7.5,7.5,7.5,7.5c1,1,2.5,1,3.4,0c0,0,7.3-7.3,7.5-7.5\n\tc1-1,1-2.5,0-3.4c-1-1-2.5-1-3.4,0L52.4,59.7z"}));
}

IconDownloadData.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","width":"25px","height":"25px","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = IconDownloadData;

IconDownloadData.default = IconDownloadData;
